import type { Directive } from 'vue'
import { usePermissionsStore } from '@/stores/permissions'

function normalizeCodes(value: unknown): string[] | null {
  if (!value) return null
  if (Array.isArray(value)) return value.filter((c): c is string => typeof c === 'string')
  if (typeof value === 'string') return [value]
  return null
}

export const canDirective: Directive<HTMLElement> = {
  mounted(el, binding) {
    const store = usePermissionsStore()
    const required = normalizeCodes(binding.value)

    if (!required || required.length === 0) return

    const hasAccess = binding.modifiers.all
      ? store.canAll(required)
      : store.canAny(required)

    if (!hasAccess) {
      el.remove()
    }
  },
}

export default canDirective
